import { jobsActions } from "../store/reducers/jobsReducer";
import { projectActions } from "../store/reducers/projectReducer";
import * as lodash from "lodash";

export class JobCompletitionService{
    static $inject = ['store'];
    constructor(store){
        'ngInject'
        this.store = store;
    }

    m_getEnvTypes() {
        this.tickTime = new Date();
        let handleResponse = (resp) => {
            if (resp.status == -1 || resp.status >= 300) { //timeout or error
                if (!this.destroyed) {
                    this.connectionStateAddError();
                }
                return;
            }

            // this a must the update that not come from the hover the percentageComplete will be 0 at all time
            resp.data.forEach((item) => {
                item.environments.forEach((env) => {
                    delete env.percentageComplete;
                })
            })

            this._envTypes=lodash.map(resp.data, (obj) => {
                let exisEnvType = lodash.find(this._envTypes, { id: obj.id });
                if (exisEnvType === null)
                    return obj;

                let objEnvs = obj.environments;
                delete obj.environments;

                exisEnvType = lodash.assign(exisEnvType, obj);

                exisEnvType.environments = lodash.map(objEnvs, (env) => {
                    let exisEnv = lodash.find(exisEnvType.environments, { id: env.id });
                    if (exisEnv === null)
                        return env;

                    return lodash.assign(exisEnv, env);
                });

                return exisEnvType;
            });
            let envTest = this._envTypes.filter(item => item.id == 8)
            if (envTest && envTest.length > 0) {
                this.envTypeTest = envTest[0];
            }

            if (!this.destroyed) {
                this.connectionStateReset()
            }
        };
        let handleError = (resp) => {
            if (!this.destroyed) {
                this.connectionStateAddError();
            }
        };

        if ((!this.store.getState().project.editMode) || (!this.firstTimeOnEditMode)) {
            if (this.store.getState().project.editMode) {
                this.firstTimeOnEditMode = true;
            }

            //if you can take the projectId from this.projectData because its more relevant
            let currentProjId = "";
            if(this.projectData && this.projectData.parentId)
                currentProjId = this.projectData.parentId.toString();
            else
                currentProjId = this.projectId;

            this.store.dispatch({
                type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
                payload: { 
                    projId: currentProjId//this.projectId 
                },
                customErrorHandling: true,
                silentRequest: true,
            }).then(handleResponse, handleError);
        }
    };

    // Child Processes Hover View Polling Response Handler
    onProcessUpdateReceivedData(data){
        const _this = this;
        if (this === null || !this._envTypes)
            return;
        try {
            if(this.isJobInProgress != undefined && this.isJobInProgress && (!data.data|| data.data.length == 0))
                this.isJobInProgress = false;
            if (data.data && _.isArray(data.data)) {
                data.data.forEach((execJob) => {
                    let targetProjId = execJob.JobParams.filter((jobParam) => jobParam.Key === "TARGET_PROJECT")
                        .map((jobParam) => parseInt(jobParam.Value))
                        .filter((val, index, self) => self.indexOf(val) === index)
                        .find((val, index) => index >= 0);
                    if (targetProjId == null)
                        return;
                    try {
                        this.isJobInProgress = true;
                        const jobCompletionPercentage = this.updateJobCompletionPercentage(execJob)
                        _this.store.dispatch({ type: jobsActions.SET_JOB_COMPLETION_PERCENTAGE, payload: { jobCompletionPercentage: jobCompletionPercentage } });
                        let targetEnvNames = execJob.EnvironmentNames.split(',');
                        _this.$timeout(() => {
                            targetEnvNames.forEach((targetEnvName) => {
                                if (_this.envTypeTest) {
                                    this.UpdateEnvType(_this.envTypeTest, targetEnvName, execJob)
                                }
                                if(_this._envTypes.length > 0)
                                _this._envTypes.forEach((env)=> this.UpdateEnvType(env, targetEnvName, execJob));
                            });
                            _this.$scope.$apply();
                        }, 1);
                    }
                    catch (e) { // we ignore some reason there no EnvironmentNames so let this failed without errors
                    }
                });
            }
        }
        catch (e) {
            return;
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/jobCompletitionService.js